import { createRoot } from "react-dom/client";
import SessionDialogUI from "../Session";

/**
 * Renders the Session Dialog UI content.
 */
export default class SessionDialog {
  constructor(options) {
    const root = createRoot(options.rootElement);
    root.render(<SessionDialogUI />);
  }
}
